import { wizardNoPersist } from "./state";
const { actions } = wizardNoPersist;

export const wizardNoPersistActions = {
  ...actions,
};
